import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const team = [
  {
    name: "Isabelle Fontaine",
    title: "Master Colorist & Founder",
    origin: "Paris, France",
    specialty: "Balayage, Color Correction, Lived-In Color",
    bio: "Isabelle trained at the prestigious Jacques Dessange Academy in Paris before spending a decade perfecting her craft in top Parisian salons. She brought her signature sun-kissed balayage technique to Las Vegas in 2013 and founded VegasGlamHair with a mission to deliver European-quality results in an accessible luxury setting. Her color work has been featured in Vegas Magazine and Harper's Bazaar.",
    awards: ["Best Colorist – Vegas Style Awards 2024", "Wella Master Color Expert", "Schwarzkopf Color Ambassador"],
    image: "https://public.readdy.ai/ai/img_res/1fa97200566b3c59da516708172c0c08.jpg",
    instagram: "@isabelle.glamhair",
  },
  {
    name: "Margot Delacroix",
    title: "Color Director",
    origin: "Lyon, France",
    specialty: "Platinum, Vivid Color, Toning",
    bio: "With roots in Lyon's avant-garde salon scene, Margot is the go-to specialist for platinum transformations and editorial vivid color. She holds advanced certifications from Wella and L'Oréal Professionnel and has worked backstage at Paris Fashion Week. Her meticulous approach to toning and bond protection ensures every blonde she creates is as healthy as it is radiant.",
    awards: ["L'Oréal Professionnel Expert", "Wella Color Specialist", "Vegas Magazine Top Stylist 2025"],
    image: "https://readdy.ai/api/search-image?query=sophisticated%20professional%20female%20hair%20colorist%20European%20French%20woman%2035%20confident%20elegant%20portrait%20luxury%20salon%20warm%20golden%20lighting%20editorial%20photography%20high%20fashion&width=700&height=900&seq=team2&orientation=portrait",
    instagram: "@margot.glamhair",
  },
  {
    name: "Sofia Ricci",
    title: "Senior Stylist & Bridal Specialist",
    origin: "Milan, Italy",
    specialty: "Bridal Styling, Extensions, Updos",
    bio: "Sofia's Italian flair and meticulous eye for detail make her one of Las Vegas's most sought-after bridal stylists. Trained at the Toni&Guy Academy in Milan and the Vidal Sassoon School in London, she combines architectural precision with romantic sensibility. Sofia has styled over 300 brides and regularly works with luxury wedding planners on the Strip.",
    awards: ["Best Bridal Stylist – Nevada Bridal Expo 2024", "Toni&Guy Academy Graduate", "Great Lengths Extension Specialist"],
    image: "https://readdy.ai/api/search-image?query=beautiful%20professional%20female%20hair%20stylist%20Italian%20European%20woman%2038%20portrait%20luxury%20salon%20warm%20golden%20lighting%20elegant%20editorial%20photography%20confident%20smile%20high-end&width=700&height=900&seq=team3&orientation=portrait",
    instagram: "@sofia.glamhair",
  },
  {
    name: "Elena Vasquez",
    title: "Precision Cut Specialist",
    origin: "Madrid, Spain",
    specialty: "Architectural Cuts, Extensions, Men's Grooming",
    bio: "Elena trained under renowned Spanish master stylist Llongueras in Barcelona before earning her advanced diploma at the Vidal Sassoon Academy in London. Known for her extraordinary precision and geometric cutting technique, she creates haircuts that grow out beautifully and require minimal styling. Her client list includes CEOs, TV personalities, and Las Vegas entertainers.",
    awards: ["Vidal Sassoon Academy Graduate", "Goldwell Style Leader", "Best Cut – VegasGlamHair Client Choice 2025"],
    image: "https://readdy.ai/api/search-image?query=professional%20female%20hair%20stylist%20Spanish%20European%20woman%2042%20portrait%20luxury%20hair%20salon%20warm%20lighting%20black%20uniform%20editorial%20beauty%20photography%20confident%20sophisticated&width=700&height=900&seq=team4&orientation=portrait",
    instagram: "@elena.glamhair",
  },
];

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Hero */}
      <section className="relative w-full h-72 md:h-96 overflow-hidden">
        <img src="https://readdy.ai/api/search-image?query=luxury%20hair%20salon%20team%20group%20photo%20European%20stylists%20professional%20upscale%20Las%20Vegas%20beauty%20studio%20warm%20golden%20lighting%20editorial%20photography&width=1920&height=600&seq=teambanner&orientation=landscape" alt="Our Team" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/55 flex flex-col items-center justify-center text-center px-6">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3">The Talent</span>
          <h1 className="text-white text-4xl md:text-6xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Meet Our Stylists</h1>
          <p className="text-white/70 mt-4 text-sm max-w-lg">European-trained masters who chose Las Vegas as their canvas.</p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto flex flex-col gap-20">
          {team.map((member, i) => (
            <div key={member.name} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
              <div className={`${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="w-full h-[480px] rounded-lg overflow-hidden">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top" />
                </div>
              </div>
              <div className={`${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <p className="text-[#C9A96E] text-xs font-bold tracking-[0.3em] uppercase mb-2">{member.origin}</p>
                <h2 className="text-neutral-900 text-3xl font-bold mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{member.name}</h2>
                <p className="text-neutral-500 text-sm mb-1">{member.title}</p>
                <p className="text-neutral-400 text-xs mb-6 italic">{member.specialty}</p>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6">{member.bio}</p>
                <div className="mb-6">
                  <p className="text-xs font-bold tracking-widest uppercase text-neutral-400 mb-3">Credentials & Awards</p>
                  <ul className="flex flex-col gap-2">
                    {member.awards.map(a => (
                      <li key={a} className="flex items-center gap-2 text-sm text-neutral-600">
                        <i className="ri-medal-line text-[#C9A96E] text-base shrink-0"></i>{a}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex gap-4 items-center">
                  <Link to="/booking" className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-8 py-3 rounded-sm hover:bg-[#b8934f] transition-colors cursor-pointer whitespace-nowrap">Book with {member.name.split(" ")[0]}</Link>
                  <span className="text-neutral-400 text-sm">{member.instagram}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
